// Shared helpers + small primitives for the Customer Profile tabs.

export function canEditCustomerNotes(user) {
  const role = user?.account_type || user?.role;
  if (role === "business_owner" || role === "platform_admin" || role === "staff") return true;
  return (user?.permissions || []).includes("bookings");
}

export function Info({ label, value }) {
  return (
    <div>
      <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{label}</div>
      <div className="mt-0.5">{value}</div>
    </div>
  );
}
